export const TutorialsInLearn = {
  flow: 'y',
  state: {
    limit: 5
  },
  tag: 'form',
  align: 'start',
  gap: 'A',
  position: 'relative',
  onSubmit: (ev, el, s) => {
    ev.preventDefault()
    el.call('createItem', s.type, s.key)
  },
  CaptionTitle: {
    Text: {
      text: '{{ learn.tutorials.title | polyglot }}'
    }
  },
  Flex: {
    flow: 'y',
    gap: 'A',
    margin: '- - - -X',
    childExtends: 'TutorialItemInLearn',
    childrenAs: 'state',
    children: (el, s) =>
      [
        {
          title: 'learn.video.gettingStarted.title',
          descr: 'learn.video.gettingStarted.descr',
          youtubeId: 'jYU0soXY-To',
          duration: '14:31'
        },
        {
          title: 'learn.video.symbolsLibrary.title',
          descr: 'learn.video.symbolsLibrary.descr',
          youtubeId: '1Vut-DOrfvg',
          duration: '1:50'
        },
        {
          title: 'learn.video.whatIsSymbols.title',
          descr: 'learn.video.whatIsSymbols.descr',
          youtubeId: 'P_jjCTzS0-w',
          duration: '1:15'
        },
        {
          title: 'learn.video.navigation.title',
          descr: 'learn.video.navigation.descr',
          youtubeId: 'rugrjZ6WrDM',
          duration: '4:25'
        },
        {
          title: 'learn.video.calculator.title',
          descr: 'learn.video.calculator.descr',
          youtubeId: 'dPZCwGEysdI',
          duration: '5:23'
        },
        {
          title: 'learn.video.components.title',
          descr: 'learn.video.components.descr',
          youtubeId: 'ScXOBnJ6ZIU',
          duration: '2:31'
        },
        {
          title: 'learn.video.pages.title',
          descr: 'learn.video.pages.descr',
          youtubeId: '-qWxYRR15DM',
          duration: '0:56'
        },
        {
          title: 'learn.video.codeEditor.title',
          descr: 'learn.video.codeEditor.descr',
          youtubeId: 'W2sEhoLA0Dc',
          duration: '0:23'
        },
        {
          title: 'learn.video.files.title',
          descr: 'learn.video.files.descr',
          youtubeId: 'P9D8A0258Ro',
          duration: '1:58'
        },
        {
          title: 'learn.video.colors.title',
          descr: 'learn.video.colors.descr',
          youtubeId: 'i4JuUp39n50',
          duration: '2:02'
        },
        {
          title: 'learn.video.spacing.title',
          descr: 'learn.video.spacing.descr',
          youtubeId: 'xFgl6jG2yrw',
          duration: '2:35'
        },
        {
          title: 'learn.video.icons.title',
          descr: 'learn.video.icons.descr',
          youtubeId: 'rPfSew0RGZc',
          duration: '2:19'
        }
      ].slice(0, s.limit || 30)
  },
  InsertSectionShadow: {
    left: '-C1',
    right: '-C1',
    bottom: 'C1'
  },
  Button: {
    extends: ['CanvasButton', 'Button'],
    zIndex: 2,
    margin: '- - - -Y2',
    icon: (el, s) => 'arrow angle ' + (s.limit === 5 ? 'down' : 'up'),
    text: (el, s) => el.call('polyglot', s.limit === 5 ? 'learn.video.more' : 'learn.video.less'),
    gap: 'Y1',
    padding: 'Y2 Z2',
    color: 'caption',
    fontSize: 'Z2',
    Icon: {
      order: 2
    },
    onClick: (ev, el, s) => {
      s.update({
        limit: s.limit === 5 ? 30 : 5
      })
    }
  }
}
